<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">指标库列表</h3>
    <div style="display: flex;">
      <div style="width:300px;padding:8px;box-sizing: border-box;box-shadow: rgb(229 229 229) 0px 0px 1px 1px;min-height: 500px;">
        <el-tree :data="treeArr" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </div>
      <div style="flex:1;overflow: auto;margin-left: 8px;">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
          <el-form-item>
            <el-button type="primary" @click="handleAdd()">新建标准</el-button>
            <!-- <el-button type="primary" @click="handleNode">获取当前TreeNode</el-button> -->
          </el-form-item>
        </el-form>
        <custom-table :data="tableData" ref="table" border style="width: 100%">
          <custom-table-column prop="cate_1" label="一级分类" width="160">
          </custom-table-column>
          <custom-table-column prop="cate_2" label="二级分类" width="160">
          </custom-table-column>
          <custom-table-column prop="name" label="三级检查项目" min-width="200">
          </custom-table-column>
          <custom-table-column prop="value" label="检查标准" min-width="200">
          </custom-table-column>
          <custom-table-column prop="display_order" label="排序" width="100">
          </custom-table-column>
          <custom-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </custom-table-column>
        </custom-table>
        <!-- <div class="pageLine">
          <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
        </div> -->
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="一级分类" prop="cate_1">
          <el-input v-model="ruleForm.cate_1" placeholder="请输入一级分类" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="二级分类" prop="cate_2">
          <el-input v-model="ruleForm.cate_2" placeholder="请输入二级分类" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="三级检查项目" prop="title">
          <el-input v-model="ruleForm.title" placeholder="请输入检查项目" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="排  序" prop="display_order">
          <el-input v-model.number="ruleForm.display_order" placeholder="请输入人数" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="检查标准" prop="content">
          <el-input type="textarea" v-model="ruleForm.content" style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';

export default {
  name: 'trainingRoom',
  mixins: [mixinList],
  data() {
    return {
      classRooms: [],
      institutes: [
        { isid: '1', ismc: '机电学院' },
        { isid: '2', ismc: '土木学院' },
      ],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      formInline: {
        structure_1: '',
        major: '',
        training_room: '',
        train_name: '',
        teacher: '',
      },
      levell: [1, 2],
      levell1: [1, 2, 3],
      selectName: '',
      organLabel: '',
      ruleForm: {
        cate_1: '',
        cate_2: '',
        title: '',
        content: '',
        display_order: 0,
      },
      rules: {
        cate_1: [{ required: true, message: '请输入一级分类', trigger: 'blur' }],
        cate_2: [{ required: true, message: '请输入二级分类', trigger: 'blur' }],
        display_order: [{ type: 'number', message: '排序必须为数字值' }],
        title: [{ required: true, message: '请输入检查项目', trigger: 'blur' }],
        content: [{ required: true, message: '请输入检查标准', trigger: 'blur' }],
      },
      type: 'add',
      title: '新增',
      tableName: '实训日志',
      treeArr: [],
      tableArr: [],
      allArr: [],
      currentNode: null,
    };
  },
  created() {},
  mounted() {
    // this.getList();
    // this.$store.dispatch('getTarinMent');
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleNodeClick(nodeData) {
      console.log(nodeData);
      this.currentNode = nodeData;
      this.tableData = [];
      if (nodeData.children) {
        nodeData.children.map((item) => {
          if (item.list) {
            this.tableData = this.tableData.concat(item.list);
          }
        });
      }
      if (nodeData.list) {
        this.tableData = nodeData.list;
      }
    },
    handleEdit(row, filterArr = []) {
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = {
        id: row.id,
        cate_1: row.cate_1,
        cate_2: row.cate_2,
        title: row.name,
        content: row.value,
        display_order: row.display_order,
      };
      this.centerDialogVisible = true;
    },
    handleNode() {
      console.log(this.currentNode);
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.room_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/safety_check/standard/delete/${params.id}`, 'delete', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/safety_check/standard/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/safety_check/standard/edit/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.tableData1 = [];
      console.log(this.ruleForm);
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.major = strArr[1];
        this.ruleForm.class = strArr[2];
      }
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.major = '';
        this.ruleForm.class = '';
      }

      // this.ruleForm.type_value = this.selectNode.structure_ids;
      // this.organs = [this.selectNode];
    },
    handleQuery() {
      // this.beforeQuery();
      // this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      // params.page = this.$refs.pageChild.page;
      // params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/safety_check/standard/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.treeArr = res.data;
        this.tableData = [];
        // console.log( this.treeArr)
        // this.tableData = res.data.data;
        // this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
